<template>
  <main>
    <sub-tab-header />
    <div class="tab-content">
      <div class="tab-pane active show">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="radio radio-inline">
                        <input type="radio" v-model="searchType" id="search-type-1" value="1">
                        <label for="search-type-1">強制調撥總表</label>
                    </div>
                    <div class="radio radio-inline">
                        <input type="radio" v-model="searchType" id="search-type-2" value="2">
                        <label for="search-type-2">離退職人員撥出</label>
                    </div>
                    <div class="radio radio-inline">
                        <input type="radio" v-model="searchType" id="search-type-3" value="3">
                        <label for="search-type-3">2年內新人AFP/FCP撥入</label>
                    </div>
                    <div class="radio radio-inline">
                        <input type="radio" v-model="searchType" id="search-type-4" value="4">
                        <label for="search-type-4">全單位未訪件</label>
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-12">
                  <form class="form">
                    <div class="form-group row">
                        <label class="col-1 text-right">月份</label>
                        <div class="col-11">
                            <select class="form-control form-control-inline ml-0" v-model="form.startYear">
                                <option value="108">108 年</option>
                            </select>
                            <span class="text">/</span>
                            <select class="form-control form-control-inline" v-model="form.startMonth">
                                <option value="1">1 月</option>
                            </select>
                            <span class="text">～</span>
                            <select class="form-control form-control-inline" v-model="form.endYear">
                                <option value="108">108 年</option>
                            </select>
                            <span class="text">/</span>
                            <select class="form-control form-control-inline" v-model="form.endMonth">
                                <option value="2">2 月</option>
                            </select>
                            <a @click="searchData()" class="btn btn-primary mt-0">查詢</a>
                            <div v-if="searchType=='2'">
                              <div class="checkbox">
                                <input type="checkbox" v-model="form.vip" id="onlyvip" value="true">
                                <label for="onlyvip">僅顯示VIP</label>
                              </div>
                            </div>
                        </div>
                    </div>
                  </form>

                  <div class="breadcrumb row" v-if="tableRow && tableRow.length">
                    <label class="col-1 text-right">路徑</label>
                    <div class="col-11">
                      <ul class="breadcrumb-list">
                        <li :class="{
                          'active': currentRowID == null
                        }"><a role="button" @click="currentRowID = null">全部</a></li>
                        <li class="bread"
                        :class="{
                          'active': bread.id === currentRowID
                        }"
                        v-for="(bread, i) in breadcrumbs"
                        :key="`bread-${i}`">
                          <a role="button" @click="currentRowID = bread.id">{{bread.name}}</a>
                        </li>
                      </ul>
                    </div>
                  </div>

                </div>
                <div class="col-12" v-if="searchType==1">
                    <table class="table datatable insurance-green">
                        <thead>
                            <tr>
                                <th rowspan="2" width="100">系統別</th>
                                <th colspan="3" class="text-center">離/退(撥出)</th>
                                <th colspan="3" class="text-center">2年內/AFP/CFP(撥入)</th>
                                <th colspan="3" class="text-center">全單位未訪件</th>
                                <th colspan="3" class="text-center">合計</th>
                            </tr>
                            <tr>
                                <th class="text-center">應撥保戶</th>
                                <th class="text-center">已撥保戶</th>
                                <th class="text-center">完成率</th>
                                <th class="text-center">應撥保戶</th>
                                <th class="text-center">已撥保戶</th>
                                <th class="text-center">完成率</th>
                                <th class="text-center">應撥保戶</th>
                                <th class="text-center">已撥保戶</th>
                                <th class="text-center">完成率</th>
                                <th class="text-center">應撥保戶</th>
                                <th class="text-center">已撥保戶</th>
                                <th class="text-center">完成率</th>
                            </tr>
                        </thead>
                        <tbody v-if="tableRow && tableRow.length">
                          <tr v-for="(row, rid) in tableRow"
                          :key="`row-${rid}`">
                            <td>
                              <a v-if="row.child" @click="currentRowID = row.id" class="link text-underline">{{row.type}}</a>
                              <span v-else>{{row.type}}</span>
                            </td>
                            <td class="text-right">{{row.leave1 | numberFormat}}</td>
                            <td class="text-right">{{row.leave2 | numberFormat}}</td>
                            <td class="text-right">{{(row.leave2 / row.leave1 * 100).toFixed(2)}}%</td>
                            <td class="text-right">{{row.AFP1 | numberFormat}}</td>
                            <td class="text-right">{{row.AFP2 | numberFormat}}</td>
                            <td class="text-right">{{(row.AFP2 / row.AFP1 * 100).toFixed(2)}}%</td>
                            <td class="text-right">{{row.allleave1 | numberFormat}}</td>
                            <td class="text-right">{{row.allleave2 | numberFormat}}</td>
                            <td class="text-right">{{(row.allleave2 / row.allleave1  * 100).toFixed(2)}}%</td>
                            <td class="text-right">{{row.leave1 + row.AFP1 + row.allleave1 | numberFormat}}</td>
                            <td class="text-right">{{row.leave2 + row.AFP2 + row.allleave2 | numberFormat}}</td>
                            <td class="text-right">{{((row.leave2 + row.AFP2 + row.allleave2) / (row.leave1 + row.AFP1 + row.allleave1) * 100).toFixed(2)}}%</td>
                          </tr>
                        </tbody>
                        <tbody v-else-if="currentRowID && !tableRow.length">
                            <tr>
                                <td class="empty-block bg-white" colspan="13">
                                    <h1 class="bg-white">無任何資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="empty-block bg-white" colspan="13">
                                    <h1 class="bg-white">點擊查詢顯示資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot v-if="tableRow && tableRow.length">
                          <tr class="bg-white">
                            <th>合計</th>
                            <th class="text-right">{{countTotal('leave1') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('leave2') | numberFormat}}</th>
                            <th class="text-right">{{(countTotal('leave2') / countTotal('leave1') * 100).toFixed(2)}} %</th>
                            <th class="text-right">{{countTotal('AFP1') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('AFP2') | numberFormat}}</th>
                            <th class="text-right">{{(countTotal('AFP2') / countTotal('AFP1') * 100).toFixed(2)}} %</th>
                            <th class="text-right">{{countTotal('allleave1') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('allleave2') | numberFormat}}</th>
                            <th class="text-right">{{(countTotal('allleave2') / countTotal('allleave1') * 100).toFixed(2)}} %</th>
                            <th class="text-right">{{countTotal('leave1') + countTotal('AFP1') + countTotal('allleave1') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('leave2') + countTotal('AFP2') + countTotal('allleave2') | numberFormat}}</th>
                            <th class="text-right">{{((countTotal('leave2') + countTotal('AFP2') + countTotal('allleave2')) / (countTotal('leave1') + countTotal('AFP1') + countTotal('allleave1')) * 100).toFixed(2)}}%</th>
                          </tr>
                        </tfoot>
                    </table>
                    <div v-if="tableRow && tableRow.length">
                        <p>
                            <span class="d-inline-block align-top">2年內(撥入)：</span>
                            <span class="d-inline-block">
                              應撥保戶-新人晉升時件數差額-下限-目前保戶數<br/>
                              已撥保戶-採個別業務員計算，if 差額-N-20，已撥保戶最多-N-20
                            </span>
                        </p>

                        <p>
                            月份 ➔ 對離/退職人員，係指離職生效日對應月份<br/>
                            月份 ➔ 對2年內新人，應撥=(晉升時)期初件數(差額)<br/>
                            如有疑問，請洽總公司業務部業務企劃科，(02)27551399#2177、2056、2032
                        </p>
                    </div>
                </div>

                <div class="col-12" v-if="searchType==2">
                    <table class="table datatable insurance-green" v-if="breadcrumbs.length>1 && breadcrumbs.map(bred => bred.id).indexOf(currentRowID) == (breadcrumbs.length - 1)">
                        <thead>
                            <tr>
                                <th width="100">離/退職業務員姓名</th>
                                <th class="text-center">應撥保戶</th>
                                <th class="text-center">未撥保戶</th>
                                <th class="text-center">已撥保戶(期限內)</th>
                                <th class="text-center">已撥保戶(逾期)</th>
                                <th class="text-center">完成率</th>
                            </tr>
                        </thead>
                        <tbody v-if="tableRow && tableRow.length">
                          <tr v-for="(row, rid) in tableRow"
                          :key="`row-${rid}`">
                            <td>{{row.name}}</td>
                            <td class="text-right">{{row.client | numberFormat}}</td>
                            <td class="text-right">{{row.clientIsTransfer | numberFormat}}</td>
                            <td class="text-right">{{row.clientNotTransferInTime | numberFormat}}</td>
                            <td class="text-right">{{row.clientNotTransferDelay | numberFormat}}</td>
                            <td class="text-right">{{row.complete}}%</td>
                          </tr>
                        </tbody>
                        <tbody v-else-if="currentRowID && !tableRow.length">
                            <tr>
                                <td class="empty-block bg-white" colspan="13">
                                    <h1 class="bg-white">無任何資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="empty-block bg-white" colspan="13">
                                    <h1 class="bg-white">點擊查詢顯示資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot v-if="tableRow && tableRow.length">
                          <tr class="bg-white">
                            <th class="text-left">合計</th>
                            <th class="text-right">{{countTotal('client') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('clientIsTransfer') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('clientNotTransferInTime') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('clientNotTransferDelay') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('complete')}}%</th>
                          </tr>
                        </tfoot>
                    </table>
                    <table class="table datatable insurance-green" v-else>
                        <thead>
                            <tr>
                                <th width="100">系統別</th>
                                <th class="text-center">離/退業務員</th>
                                <th class="text-center">應撥保戶</th>
                                <th class="text-center">未撥保戶</th>
                                <th class="text-center">已撥保戶(期限內)</th>
                                <th class="text-center">已撥保戶(逾期)</th>
                                <th class="text-center">完成率</th>
                            </tr>
                        </thead>
                        <tbody v-if="tableRow && tableRow.length">
                          <tr v-for="(row, rid) in tableRow"
                          :key="`row-${rid}`">
                            <td>
                              <a v-if="row.child" @click="currentRowID = row.id" class="link text-underline">{{row.type}}</a>
                              <span v-else>{{row.type}}</span>
                            </td>
                            <td class="text-right">{{row.leave | numberFormat}}</td>
                            <td class="text-right">{{row.client | numberFormat}}</td>
                            <td class="text-right">{{row.clientIsTransfer | numberFormat}}</td>
                            <td class="text-right">{{row.clientNotTransferInTime | numberFormat}}</td>
                            <td class="text-right">{{row.clientNotTransferDelay | numberFormat}}</td>
                            <td class="text-right">{{row.complete}}%</td>
                          </tr>
                        </tbody>
                        <tbody v-else-if="currentRowID && !tableRow.length">
                            <tr>
                                <td class="empty-block bg-white" colspan="13">
                                    <h1 class="bg-white">無任何資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="empty-block bg-white" colspan="13">
                                    <h1 class="bg-white">點擊查詢顯示資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot v-if="tableRow && tableRow.length">
                          <tr class="bg-white">
                            <th>合計</th>
                            <th class="text-right">{{countTotal('leave') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('client') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('clientIsTransfer') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('clientNotTransferInTime') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('clientNotTransferDelay') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('complete')}}%</th>
                          </tr>
                        </tfoot>
                    </table>

                    <div v-if="tableRow && tableRow.length">
                        <p>
                            <span class="d-inline-block align-top">2年內(撥入)：</span>
                            <span class="d-inline-block">
                              應撥保戶-新人晉升時件數差額-下限-目前保戶數<br/>
                              已撥保戶-採個別業務員計算，if 差額-N-20，已撥保戶最多-N-20
                            </span>
                        </p>

                        <p>
                            月份 ➔ 對離/退職人員，係指離職生效日對應月份<br/>
                            月份 ➔ 對2年內新人，應撥=(晉升時)期初件數(差額)<br/>
                            如有疑問，請洽總公司業務部業務企劃科，(02)27551399#2177、2056、2032
                        </p>
                    </div>
                </div>

                <div class="col-12" v-if="searchType==3">
                    <table class="table datatable insurance-green">
                        <thead>
                            <tr>
                                <th rowspan="2" width="100">系統別</th>
                                <th colspan="6" class="text-center">2年內新人</th>
                                <th colspan="6" class="text-center">AFP & CFP</th>
                            </tr>
                            <tr>
                                <th class="text-center">業務員</th>
                                <th class="text-center">應撥保戶</th>
                                <th class="text-center">未撥保戶</th>
                                <th class="text-center">已撥保戶(期限內)</th>
                                <th class="text-center">已撥保戶(逾期)</th>
                                <th class="text-center">完成率</th>
                                <th class="text-center">業務員</th>
                                <th class="text-center">應撥保戶</th>
                                <th class="text-center">未撥保戶</th>
                                <th class="text-center">已撥保戶(期限內)</th>
                                <th class="text-center">已撥保戶(逾期)</th>
                                <th class="text-center">完成率</th>
                            </tr>
                        </thead>
                        <tbody v-if="tableRow && tableRow.length">
                          <tr v-for="(row, rid) in tableRow"
                          :key="`row-${rid}`">
                            <td>
                              <a v-if="row.child" @click="currentRowID = row.id" class="link text-underline">{{row.type}}</a>
                              <span v-else>{{row.type}}</span>
                            </td>
                            <td class="text-right">{{row.twoyearSales | numberFormat}}</td>
                            <td class="text-right">{{row.twoyearClient | numberFormat}}</td>
                            <td class="text-right">{{row.twoyearClentNotTransfer | numberFormat}}</td>
                            <td class="text-right">{{row.twoyearClentHasTransfer | numberFormat}}</td>
                            <td class="text-right">{{row.twoyearClentDelayTransfer | numberFormat}}</td>
                            <td class="text-right">{{row.twoyearComplete}}%</td>
                            <td class="text-right">{{row.AFPSales | numberFormat}}</td>
                            <td class="text-right">{{row.AFPClient | numberFormat}}</td>
                            <td class="text-right">{{row.AFPClentNotTransfer | numberFormat}}</td>
                            <td class="text-right">{{row.AFPClentHasTransfer | numberFormat}}</td>
                            <td class="text-right">{{row.AFPClentDelayTransfer | numberFormat}}</td>
                            <td class="text-right">{{row.AFPComplete}}%</td>
                          </tr>
                        </tbody>
                        <tbody v-else-if="currentRowID && !tableRow.length">
                            <tr>
                                <td class="empty-block bg-white" colspan="13">
                                    <h1 class="bg-white">無任何資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="empty-block bg-white" colspan="13">
                                    <h1 class="bg-white">點擊查詢顯示資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot v-if="tableRow && tableRow.length">
                          <tr class="bg-white">
                            <th class="text-left">合計</th>
                            <th class="text-right">{{countTotal('twoyearSales') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('twoyearClient') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('twoyearClentNotTransfer') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('twoyearClentHasTransfer') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('twoyearClentDelayTransfer') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('twoyearComplete')}}%</th>
                            <th class="text-right">{{countTotal('AFPSales') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('AFPClient') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('AFPClentNotTransfer') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('AFPClentHasTransfer') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('AFPClentDelayTransfer') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('AFPComplete')}}%</th>
                          </tr>
                        </tfoot>
                    </table>
                   
                    <div v-if="tableRow && tableRow.length">
                        <p>
                            <span class="d-inline-block align-top">2年內(撥入)：</span>
                            <span class="d-inline-block">
                              2年內(撥入)：應撥保戶-新人晉升時件數差額-下限-目前保戶數<br/>
                              已撥保戶-採個別業務員計算，if 差額-N-20，已撥保戶最多-N-20
                            </span>
                        </p>

                        <p>
                            如有疑問，請洽總公司業務部業務企劃科，(02)27551399#2177、2056、2032
                        </p>
                    </div>
                </div>

                <div class="col-12" v-if="searchType==4">
                  <table class="table datatable insurance-green">
                    <thead>
                      <tr>
                        <th rowspan="2" width="100">系統別</th>
                        <th class="text-center">業務員</th>
                        <th class="text-center">應撥保戶</th>
                        <th class="text-center">未撥保戶</th>
                        <th class="text-center">已撥保戶(期限內)</th>
                        <th class="text-center">已撥保戶(逾期)</th>
                        <th class="text-center">完成率</th>
                      </tr>
                    </thead>
                    <tbody v-if="tableRow && tableRow.length">
                      <tr v-for="(row, rid) in tableRow"
                      :key="`row-${rid}`">
                        <td>
                          <a v-if="row.child" @click="currentRowID = row.id" class="link text-underline">{{row.type}}</a>
                          <span v-else>{{row.type}}</span>
                        </td>
                        <td class="text-right">{{row.sales | numberFormat}}</td>
                        <td class="text-right">{{row.client | numberFormat}}</td>
                        <td class="text-right">{{row.clentNotTransfer | numberFormat}}</td>
                        <td class="text-right">{{row.clentHasTransfer | numberFormat}}</td>
                        <td class="text-right">{{row.clentDelayTransfer | numberFormat}}</td>
                        <td class="text-right">{{row.complete}}%</td>
                      </tr>
                    </tbody>
                    <tbody v-else-if="currentRowID && !tableRow.length">
                        <tr>
                            <td class="empty-block bg-white" colspan="7">
                                <h1 class="bg-white">無任何資料</h1>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td class="empty-block bg-white" colspan="7">
                                <h1 class="bg-white">點擊查詢顯示資料</h1>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot v-if="tableRow && tableRow.length">
                      <tr class="bg-white">
                        <th class="text-left">合計</th>
                        <th class="text-right">{{countTotal('sales') | numberFormat}}</th>
                        <th class="text-right">{{countTotal('client') | numberFormat}}</th>
                        <th class="text-right">{{countTotal('clentNotTransfer') | numberFormat}}</th>
                        <th class="text-right">{{countTotal('clentHasTransfer') | numberFormat}}</th>
                        <th class="text-right">{{countTotal('clentDelayTransfer') | numberFormat}}</th>
                        <th class="text-right">{{countTotal('complete')}}%</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
            </div>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import SubTabHeader from '@/desktop/components/submanager/TabHeader'
import Avatar from '@/components/Avatar'
import Level from '@/components/Level'

const dataTree1 = [
  {
    parent: null,
    id: 1,
    type: '專招',
    leave1: 5730,
    leave2: 4930,
    AFP1: 14360,
    AFP2: 3861,
    allleave1: 114106,
    allleave2: 52517,
    child: true
  },
  {
    parent: null,
    id: 2,
    type: '展業',
    leave1: 5730,
    leave2: 4930,
    AFP1: 14360,
    AFP2: 3861,
    allleave1: 114106,
    allleave2: 52517,
    child: true
  },
  {
    parent: 1,
    id: 3,
    type: '專招台北第二區部',
    leave1: 5730,
    leave2: 4930,
    AFP1: 14360,
    AFP2: 3861,
    allleave1: 114106,
    allleave2: 52517,
    child: true
  },
  {
    parent: 1,
    id: 4,
    type: '專招台北第ㄧ區部',
    leave1: 5730,
    leave2: 4930,
    AFP1: 14360,
    AFP2: 3861,
    allleave1: 114106,
    allleave2: 52517,
    child: true,
  },
  {
    parent: 1,
    id: 5,
    type: '專招台中區部',
    leave1: 5730,
    leave2: 4930,
    AFP1: 14360,
    AFP2: 3861,
    allleave1: 114106,
    allleave2: 52517,
    child: true,
  }, 
  {
    parent: 1,
    id: 6,
    type: '專招台南區部',
    leave1: 5730,
    leave2: 4930,
    AFP1: 14360,
    AFP2: 3861,
    allleave1: 114106,
    allleave2: 52517,
    child: true,
  },
  {
    parent: 3,
    id: 7,
    type: '專招台北第二區部',
    leave1: 5730,
    leave2: 4930,
    AFP1: 14360,
    AFP2: 3861,
    allleave1: 114106,
    allleave2: 52517,
    child: false
  },
  {
    parent: 3,
    id: 8,
    type: '專招台北第二區部',
    leave1: 5730,
    leave2: 4930,
    AFP1: 14360,
    AFP2: 3861,
    allleave1: 114106,
    allleave2: 52517,
    child: false
  },
  {
    parent: 3,
    id: 9,
    type: '專招台北第二區部',
    leave1: 5730,
    leave2: 4930,
    AFP1: 14360,
    AFP2: 3861,
    allleave1: 114106,
    allleave2: 52517,
    child: false
  }
]

const dataTree2 = [
  {
    parent: null,
    id: 1,
    type: '專招',
    leave: 997,
    client: 79581,
    clientIsTransfer: 8835,
    clientNotTransferInTime: 57355,
    clientNotTransferDelay: 13391,
    complete: 88.9,
    child: true
  },
  {
    parent: null,
    id: 2,
    type: '展業',
    leave: 997,
    client: 79581,
    clientIsTransfer: 8835,
    clientNotTransferInTime: 57355,
    clientNotTransferDelay: 13391,
    complete: 91.9,
    child: true
  },
  {
    parent: 1,
    id: 3,
    type: '專招松山推展處(二)松榮推展處',
    name: '成龍',
    leave: 997,
    client: 79581,
    clientIsTransfer: 8835,
    clientNotTransferInTime: 57355,
    clientNotTransferDelay: 13391,
    complete: 88.9,
    child: true
  },
  {
    parent: 3,
    id: 4,
    name: '成龍',
    client: 4,
    clientIsTransfer: 0,
    clientNotTransferInTime: 4,
    clientNotTransferDelay: 0,
    complete: 100,
    child: true
  }
]

const dataTree3 = [
  {
    id: 1,
    parent: null,
    type: '專招',
    twoyearSales: 1905,
    twoyearClient: 86000,
    twoyearClentNotTransfer: 34379,
    twoyearClentHasTransfer: 38088,
    twoyearClentDelayTransfer: 13533,
    twoyearComplete: 60,
    AFPSales: 11,
    AFPClient: 1970,
    AFPClentNotTransfer: 424,
    AFPClentHasTransfer: 1187,
    AFPClentDelayTransfer: 369,
    AFPComplete: 78.5
  },
  {
    id: 2,
    parent: null,
    type: '展業',
    twoyearSales: 3530,
    twoyearClient: 160033,
    twoyearClentNotTransfer: 35683,
    twoyearClentHasTransfer: 112220,
    twoyearClentDelayTransfer: 12130,
    twoyearComplete: 77.7,
    AFPSales: 4,
    AFPClient: 513,
    AFPClentNotTransfer: 25,
    AFPClentHasTransfer: 433,
    AFPClentDelayTransfer: 55,
    AFPComplete: 95.1
  }
]

const dataTree4 = [
  {
    id: 1,
    parent: null,
    type: '專招',
    sales: 3796,
    client: 67441,
    clentNotTransfer: 30693,
    clentHasTransfer: 7997,
    clentDelayTransfer: 28751,
    complete: 54.5
  },
  {
    id: 2,
    parent: null,
    type: '展業',
    sales: 10292,
    client: 289110,
    clentNotTransfer: 118917,
    clentHasTransfer: 45808,
    clentDelayTransfer: 124385,
    complete: 58.9
  }
]

export default {
  name: 'TransferTab4',
  mixins: [commonMixin],
  components: {
    SubTabHeader, Level, Avatar
  },
  computed: {
    tableRow () {
      if (this.currentRowID==0) return null
      
      switch (Number(this.searchType)) {
        case 1:
          this.dataTree = dataTree1
          break;
        case 2:
          this.dataTree = dataTree2
          break;
        case 3:
          this.dataTree = dataTree3
          break;
        case 4:
          this.dataTree = dataTree4
          break;
      }
      return this.dataTree.filter(row => row.parent == this.currentRowID)
    },
    breadcrumbs () {
      if(this.currentRowID==0)
        return []
      else
        return (this.getParentPath(this.currentRowID)).reverse()
    }
  },
  data () {
    return {
      form: {
        vip: false,
        startYear: '',
        startMonth: '',
        endYear: '',
        endMonth: ''
      },
      order: {
          index: 1,
          asc: true
      },
      dataTree: [],
      searchType: 1,
      checkModalOpen: false,
      reasonType: 1,
      transferModalOpen: false,
      currentRowID: 0
    }
  },
  watch: {
      'searchType': 'changeData'
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    getParentPath (parent) {
      let path = []
      this.dataTree.forEach(row => {
        if (row.id == parent) {
          path.push({
            id: row.id,
            name: row.type
          })
          if (row.parent) {
            path = path.concat(this.getParentPath(row.parent))
          }
        }
      })
      // console.log(parent, path)
      return path
    },
    searchData () {
      this.currentRowID = null;
      // this.getPath(this.tableRow)
    },
    countTotal (key) {
      let list =  this[''] 
      if (!this.tableRow) return
      
      let num = 0
      this.tableRow.forEach(row => {
        num += row[key]
      })

      if(key.toLowerCase().indexOf('complete') > -1) {
        num =  num/this.tableRow.length
      }
      return num
    },
    getPath (ary) {
      if (ary.parent) {

      }
    },
    columnSorting(i) {
        if (this.order.index == i) {
            this.order.asc = !this.order.asc
        } else {
            this.order.asc = true
        }
        this.order.index = i
    },
    changeData () {
        // Call API
      // this.breadcrumbs = []
      this.currentRowID = 0;
    },
    doConfirm () {
        this.warnModalMsg = "你是否確認要進行服務件調撥？"
        this.panelOpen('warnModalOpen')
    },
    doCheckAll(val) {
        if(!val)
            this.form.selected = []
        else
            this.searchResult.forEach(r => {
                this.form.selected.push(r.id)
            })
    }
  },
  beforeMount () {
  },
  mounted () {
  }
}
</script>
